import { render, staticRenderFns } from "./hoods-detail-table-panel.vue?vue&type=template&id=15ef66c0&scoped=true&lang=pug"
import script from "./hoods-detail-table-panel.vue?vue&type=script&lang=js"
export * from "./hoods-detail-table-panel.vue?vue&type=script&lang=js"
import style0 from "./hoods-detail-table-panel.vue?vue&type=style&index=0&id=15ef66c0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15ef66c0",
  null
  
)

export default component.exports